import { Box, Container, Typography, Divider, Chip, Avatar, useTheme } from "@mui/material";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import { useGetPublicSchoolInfoQuery } from "../../../../../app/authApiSlice";
import { useGetWebsiteSettingsQuery } from "../../../../../app/websiteApiSlice";
import WebsiteHeader from "../../WebsiteHeader";
import WebsiteFooter from "../../WebsiteFooter";
import SeoHead from "../../SeoHead";
import "./bold.css";

export default function BoldPost({ post, settings: settingsProp }) {
  const { data: school } = useGetPublicSchoolInfoQuery();
  const { data: settings } = useGetWebsiteSettingsQuery(undefined, { skip: !!settingsProp });
  const activeSettings = settingsProp || settings;
  const muiTheme = useTheme();
  const accent = muiTheme.palette.primary.main;

  return (
    <Box className="website-bold" sx={{ minHeight: "100vh", display: "flex", flexDirection: "column", bgcolor: "#0f0f0f" }}>
      <SeoHead title={post.seo_title || post.title} description={post.seo_description || post.excerpt} ogImage={post.seo_og_image || post.featured_image} schoolName={school?.name} />
      <WebsiteHeader school={school} navItems={activeSettings?.nav_items} variant="bold" />

      {post.featured_image && (
        <Box
          sx={{
            position: "relative",
            "& img": { width: "100%", height: 420, objectFit: "cover", display: "block" },
            "&::after": {
              content: '""', position: "absolute", inset: 0,
              background: "linear-gradient(to top, rgba(0,0,0,0.7) 0%, transparent 50%)",
            },
          }}
        >
          <img src={post.featured_image} alt={post.title} />
        </Box>
      )}

      <Container maxWidth="md" sx={{ py: 6, flex: 1 }}>
        <Box display="flex" gap={0.5} mb={2}>
          {post.categories?.map((c) => (
            <Chip key={c.id} label={c.name} size="small"
              sx={{ bgcolor: accent, color: "white", fontWeight: 700 }}
              component={Link} to={`/blog/category/${c.slug}`} clickable
            />
          ))}
        </Box>
        <Typography variant="h3" fontWeight={900} sx={{ color: "white", mb: 1 }}>{post.title}</Typography>
        <Box display="flex" alignItems="center" gap={1} mb={2} sx={{ color: "grey.500" }}>
          <Avatar sx={{ width: 28, height: 28, bgcolor: accent, fontSize: "0.75rem" }}>
            {post.author?.username?.[0]?.toUpperCase()}
          </Avatar>
          <Typography variant="body2">{post.author?.username}</Typography>
          {post.published_at && (
            <>
              <Typography variant="body2">·</Typography>
              <Typography variant="body2">{format(new Date(post.published_at), "MMMM d, yyyy")}</Typography>
            </>
          )}
        </Box>

        <Box
          className="prose-content"
          sx={{ bgcolor: "white", borderRadius: 3, p: { xs: 2.5, md: 4 } }}
          dangerouslySetInnerHTML={{ __html: post.content }}
        />
      </Container>

      <WebsiteFooter settings={activeSettings} school={school} variant="bold" />
    </Box>
  );
}
